import UIReducer from './UIReducer';
import chatsReducer from './chatsReducer';
import templatesReducer from './templatesReducer';
import savedResponsesReducer from './savedResponsesReducer';
import usersReducer from './usersReducer';
import currentUserReducer from './currentUserReducer';
import filterTagReducer from './filterTagReducer';
import chatsCountReducer from './chatsCountReducer';
import tagsReducer from './tagsReducer';
import previewMediaObjectReducer from './previewMediaObjectReducer';
import isRefreshingTemplatesReducer from './isRefreshingTemplatesReducer';
import organizationReducer from './organizationReducer';
import otpAuthReducer from './otpAuthReducer';
import restaurantsReducer from './branchReducer';
import catalogReducer from './catalogReducer';
import orderReducer from './orderReducer';
import cartReducer from './cartReducer';
import teamReducer from './teamReducer';
import { combineReducers } from '@reduxjs/toolkit';
import marketPlaceReducer from './marketPlaceReducer';
import generalReducer from './generalReducer';

const rootReducer = combineReducers({
	UI: UIReducer,
	chats: chatsReducer,
	templates: templatesReducer,
	savedResponses: savedResponsesReducer,
	tags: tagsReducer,
	users: usersReducer,
	currentUser: currentUserReducer,
	filterTag: filterTagReducer,
	chatsCount: chatsCountReducer,
	previewMediaObject: previewMediaObjectReducer,
	isRefreshingTemplates: isRefreshingTemplatesReducer,
	organization: organizationReducer,
	otpAuth: otpAuthReducer,
	restaurant: restaurantsReducer,
	supplierCatalog: catalogReducer,
	order: orderReducer,
	cart: cartReducer,
	team: teamReducer,
	marketplace: marketPlaceReducer,
	general: generalReducer,
});

export default rootReducer;
